

























import { Component, Prop, Vue } from "vue-property-decorator";
import { MiraSplitRow } from "@/utils/MiraDryingView";

/**
 * One bar per HyDry category, the whole track being its drying time and the filled parts its pauses,
 * split by kind (drying pause, power cut). Parts sit side by side from the left, separated by a 2px
 * surface gap, and the total is printed beside the bar, so a sliver never carries a value alone.
 */
@Component
export default class MiraSplitBarsComponent extends Vue {
  @Prop({ required: true })
  rows!: MiraSplitRow[];

  @Prop({ required: true })
  legend!: Array<{ label: string; color: string }>;

  @Prop({ required: true })
  trackColor!: string;
}
